import { render, staticRenderFns } from "./DatasetClassify.vue?vue&type=template&id=d64de6bc&scoped=true&"
import script from "./DatasetClassify.vue?vue&type=script&lang=js&"
export * from "./DatasetClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64de6bc",
  null
  
)

export default component.exports